import { formatCurrencySync } from '../../utils/currencyUtils';

export const formatPoints = (n) => new Intl.NumberFormat().format(parseInt(n || 0, 10));

export const formatMoney = (n) => formatCurrencySync(n);

export const formatDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};

export const formatDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, { dateStyle: 'long' });
};

export const ledgerColor = (type) => {
  switch (type) {
    case 'POINTS_EARNED':
    case 'BONUS':
      return 'success';
    case 'REWARD_REDEMPTION':
    case 'REFUND':
    case 'POINTS_EXPIRED':
      return 'error';
    default:
      return 'warning';
  }
};

export const apiError = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

/**
 * Hook-free helper: given the tenant's locations, pick the one to preselect.
 * Single active location -> auto select; otherwise null (show selector).
 */
export const preselectLocation = (locations) => {
  const active = (locations || []).filter((l) => l.active !== false);
  return active.length === 1 ? active[0] : null;
};
